import { render, staticRenderFns } from "./ModalEditCategory.vue?vue&type=template&id=3c6d0f7a&scoped=true&"
import script from "./ModalEditCategory.vue?vue&type=script&lang=js&"
export * from "./ModalEditCategory.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditCategory.vue?vue&type=style&index=0&id=3c6d0f7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6d0f7a",
  null
  
)

export default component.exports